import { useEffect, useState, useRef, useCallback } from "react";
import {
  collection,
  getDocs,
  limit,
  orderBy,
  query,
  where,
  startAfter,
} from "firebase/firestore";

import HomePage from "../../pages/home/HomePage";
import { db } from "../../matabase";

const AllTop = () => {
  const [posts, setPosts] = useState([]);
  const [err, setErr] = useState(null);
  const [load, setLoad] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [lastDoc, setLastDoc] = useState(null);

  const limitNum = 4;

  // Used for infinite scrolling
  const observer = useRef();

  // ==============================
  // FETCH TOP POSTS
  // ==============================
  const fetchData = async (reset = false) => {
    try {
      setLoad(true);
      setErr(null);

      let q;

      // First request
      if (reset || !lastDoc) {
        q = query(
          collection(db, "posts"),
          where("top", "==", "yes"),
          orderBy("date", "desc"),
          limit(limitNum),
        );
      }

      // Load more posts
      else {
        q = query(
          collection(db, "posts"),
          where("top", "==", "yes"),
          orderBy("date", "desc"),
          startAfter(lastDoc),
          limit(limitNum),
        );
      }

      const snapshot = await getDocs(q);

      // ==============================
      // POSTS FOUND
      // ==============================
      if (!snapshot.empty) {
        const newPosts = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        setPosts((prevPosts) => {
          // Remove duplicates
          const existingIds = new Set(prevPosts.map((post) => post.id));

          const uniquePosts = newPosts.filter(
            (post) => !existingIds.has(post.id),
          );

          // If this is the initial request
          if (reset) {
            return newPosts;
          }

          // Otherwise add the new posts
          return [...prevPosts, ...uniquePosts];
        });

        // Save the last document
        setLastDoc(snapshot.docs[snapshot.docs.length - 1]);

        // If we received fewer than 4 posts,
        // there are no more posts
        setHasMore(snapshot.docs.length === limitNum);
      } else {
        setHasMore(false);
      }
    } catch (error) {
      console.error("Error fetching top posts:", error);

      setErr("Something went wrong fetching posts");
    } finally {
      setLoad(false);
    }
  };

  // ==============================
  // INITIAL FETCH
  // ==============================
  useEffect(() => {
    setPosts([]);
    setLastDoc(null);
    setHasMore(true);

    fetchData(true);

    // Cleanup observer
    return () => {
      if (observer.current) {
        observer.current.disconnect();
      }
    };
  }, []);

  // ==============================
  // INFINITE SCROLL
  // ==============================
  const lastPostRef = useCallback(
    (node) => {
      // Don't trigger another request while loading
      if (load) return;

      // Stop observing if there are no more posts
      if (!hasMore) return;

      // Disconnect previous observer
      if (observer.current) {
        observer.current.disconnect();
      }

      observer.current = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting && hasMore && !load) {
            fetchData();
          }
        },
        {
          threshold: 0.1,
        },
      );

      // Observe the last post
      if (node) {
        observer.current.observe(node);
      }
    },
    [load, hasMore],
  );

  // ==============================
  // PAGE
  // ==============================
  return (
    <div>
      {/* ==========================
          ERROR
      ========================== */}
      {err ? (
        <p className="load-err">{err}</p>
      ) : (
        <HomePage posts={posts} lastPostRef={lastPostRef} />
      )}

      {/* ==========================
          LOADING
      ========================== */}
      {load && (
        <p className={posts.length === 0 ? "load-err" : ""}>Loading...</p>
      )}

      {/* ==========================
          NO BLOGS
      ========================== */}
      {!err && !load && posts.length === 0 && (
        <p className="load-err">No blogs found</p>
      )}

      {/* ==========================
          NO MORE BLOGS
      ========================== */}
      {/* {!err && !load && !hasMore && posts.length > 0 && (
        <p className="load-err"></p>
      )} */}
    </div>
  );
};

export default AllTop;
